import template from 'lodash-es/template';
import isString from 'lodash-es/isString';
import isArray from 'lodash-es/isArray';
import isNumber from 'lodash-es/isNumber';
import { oneLine } from 'common-tags';
import { cookieBase } from 'server-data/flconfigs';
import { getCookie } from '@shared/cookie';

const TRANSLATE_MODE_COOKIE = `${cookieBase}_TRANSLATE_MODE`;

const isTranslateModeEnabled = () => getCookie(TRANSLATE_MODE_COOKIE) === '1';

const getTokenizedMessage = (id, message) =>
  isTranslateModeEnabled() ? `~=[${id}|^|${message}]=~` : message;

const translate = (first, ...rest) => {
  switch (true) {
    case isString(first): {
      const text = first;
      const vars = rest[0];
      if (typeof vars === 'undefined' || !vars) {
        return text;
      }
      let result = template(text, {
        evaluate: /<\[([\s\S]+?)\]>/g,
        interpolate: /<\[=([\s\S]+?)\]>/g,
        escape: /<\[-([\s\S]+?)\]>/g,
      })(vars);
      result = template(result)(vars);
      return result;
    }
    case isArray(first): {
      return oneLine([translate.raw(first, ...rest)]);
    }
    case isNumber(first): {
      const sourceTextId = first;
      return (...args) => getTokenizedMessage(sourceTextId, translate(...args));
    }
    default: {
      throw new TypeError('Invalid argument types');
    }
  }
};

translate.raw = function rawT(literals, ...placeholders) {
  return literals.raw.reduce((str, current, index) => {
    let temp = str + current;
    if (index < placeholders.length) {
      temp += placeholders[index].toString();
    }
    return temp;
  }, '');
};

export { translate as T_ };
